import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appNoSpecialChars]',
    standalone: false
})
export class NoSpecialCharsDirective {
  // Regular expression to allow only letters, numbers, and spaces
  private readonly noSpecialCharsRegexp: RegExp = /^[a-zA-Z0-9\s]*$/;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const enteredKey: string = event.key;
    // Allow only letters, numbers, and spaces, and also allow control keys
    if (!this.noSpecialCharsRegexp.test(enteredKey)) {
      event.preventDefault(); // Prevent typing special characters
    }
  }
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const clipboardData: DataTransfer = event.clipboardData;
    const pastedText: string = clipboardData.getData('text');
    // Check if pasted text contains only allowed characters
    if (!this.noSpecialCharsRegexp.test(pastedText)) {
      event.preventDefault(); // Prevent pasting special characters
    }
  }
}
